<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用戶編號" prop="userId" >
        <a-input v-model="form.userId" placeholder="請輸入用戶編號" />
      </a-form-model-item>
      <a-form-model-item label="收入/支出" prop="inOut" >
        <a-input v-model="form.inOut" placeholder="請輸入收入/支出" />
      </a-form-model-item>
      <a-form-model-item label="類型" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="關聯資源編號" prop="resourceId" >
        <a-input v-model="form.resourceId" placeholder="請輸入關聯資源編號" />
      </a-form-model-item>
      <a-form-model-item label="米幣數量" prop="integralNum" >
        <a-input v-model="form.integralNum" placeholder="請輸入米幣數量" />
      </a-form-model-item>
      <a-form-model-item label="說明" prop="message" >
        <a-input v-model="form.message" placeholder="請輸入說明" />
      </a-form-model-item>
      <a-form-model-item label="備註" prop="remark" >
        <a-input v-model="form.remark" placeholder="請輸入內容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getIntegralBill, addIntegralBill, updateIntegralBill } from '@/api/platform/integralBill'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表單參數
      form: {
        id: null,

        userId: null,

        inOut: null,

        type: null,

        resourceId: null,

        integralNum: null,

        message: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按鈕
    cancel () {
      this.open = false
      this.reset()
    },
    // 表單重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        inOut: null,
        type: null,
        resourceId: null,
        integralNum: null,
        message: null,
        createTime: null,
        remark: null,
      }
    /*  this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })*/
    },
    /** 新增按鈕操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按鈕操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getIntegralBill({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按鈕 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateIntegralBill(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addIntegralBill(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
